import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from './config';

// Read-only API do przekrojow zapisanych w portalu glownym (apka kolegi).
// W portalu historycznie sa dwie nazwy subkolekcji — `crossSection` (singular,
// czesto starsze) i `crossSections` (plural, niektore projekty maja). Czytamy
// z obu i scalamy. _sub mowi z ktorej pochodzi dany dokument.
// Schemat dokumentu: { name, created, modified, userName, groupId, items[], settings{} }
// Items[]: { boreholeId, userDataId, boreholeName, distance, order, coordX/Y/Z, ... }
const SUBCOLLECTIONS = ['crossSection', 'crossSections'];

export const fetchExternalCrossSections = async (projectId) => {
  if (!projectId) return [];
  const results = await Promise.all(
    SUBCOLLECTIONS.map(async (sub) => {
      try {
        const colRef = collection(db, 'currentProjects', projectId, sub);
        const snap = await getDocs(colRef);
        console.log(`[Portal] ${sub}: getDocs OK, znaleziono ${snap.size} dokumentow`);
        return snap.docs.map(d => {
          const data = d.data();
          return {
            id: d.id,
            name: data.name || '(brak nazwy)',
            created: data.created || null,
            modified: data.modified || null,
            userName: data.userName || '',
            itemsCount: Array.isArray(data.items) ? data.items.length : 0,
            _sub: sub,
          };
        });
      } catch (err) {
        console.warn(`[Portal] ${sub}: BLAD (${err?.code || 'unknown'}):`, err?.message || err);
        return [];
      }
    })
  );
  return results.flat();
};

export const fetchExternalCrossSection = async (projectId, crossSectionId, sub) => {
  if (!projectId || !crossSectionId) return null;
  const subcol = SUBCOLLECTIONS.includes(sub) ? sub : SUBCOLLECTIONS[0];
  const ref = doc(db, 'currentProjects', projectId, subcol, crossSectionId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};
